import { render, staticRenderFns } from "./B2COrderImport.vue?vue&type=template&id=82625b0a&scoped=true&"
import script from "./B2COrderImport.vue?vue&type=script&lang=js&"
export * from "./B2COrderImport.vue?vue&type=script&lang=js&"
import style0 from "./B2COrderImport.vue?vue&type=style&index=0&id=82625b0a&scoped=true&lang=css&"
import style1 from "./B2COrderImport.vue?vue&type=style&index=1&id=82625b0a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82625b0a",
  null
  
)

export default component.exports